require('./lbCarHandlingModal.scss');

const $inject = [];

const lbCarHandlingModal = {
  controller: 'lbCarHandlingModalCtrl as vm',
  template: require('./lbCarHandlingModal.html'),
};

lbCarHandlingModal.$inject = $inject;

export default lbCarHandlingModal;



// WEBPACK FOOTER //
// ./src/components/lbCarHandlingModal/lbCarHandlingModal.js